/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';



export class DxoTooltipComponent extends NestedOption {
    
    get arrowLength(): number {
        return this._getOption('arrowLength');
    }
    set arrowLength(value: number) {
        this._setOption('arrowLength', value);
    }

    
    get border(): any {
        return this._getOption('border');
    }
    set border(value: any) {
        this._setOption('border', value);
    }

    
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    
    get container(): Element|
        JQuery {
        return this._getOption('container');
    }
    set container(value: Element|
        JQuery) {
        this._setOption('container', value);
    }

    
    get customizeTooltip(): Function {
        return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value: Function) {
        this._setOption('customizeTooltip', value);
    }

    
    get enabled(): boolean {
        return this._getOption('enabled');
    }
    set enabled(value: boolean) {
        this._setOption('enabled', value);
    }

    
    get font(): DevExpress.viz.Font {
        return this._getOption('font');
    }
    set font(value: DevExpress.viz.Font) {
        this._setOption('font', value);
    }

    
    get format(): DevExpress.ui.format|
        string {
        return this._getOption('format');
    }
    set format(value: DevExpress.ui.format|
        string) {
        this._setOption('format', value);
    }

    
    get opacity(): number {
        return this._getOption('opacity');
    }
    set opacity(value: number) {
        this._setOption('opacity', value);
    }

    
    get paddingLeftRight(): number {
        return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value: number) {
        this._setOption('paddingLeftRight', value);
    }

    
    get paddingTopBottom(): number {
        return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value: number) {
        this._setOption('paddingTopBottom', value);
    }

    
    get precision(): number {
        return this._getOption('precision');
    }
    set precision(value: number) {
        this._setOption('precision', value);
    }

    
    get shadow(): any {
        return this._getOption('shadow');
    }
    set shadow(value: any) {
        this._setOption('shadow', value);
    }

    
    get zIndex(): number {
        return this._getOption('zIndex');
    }
    set zIndex(value: number) {
        this._setOption('zIndex', value);
    }

    
    get horizontalAlignment(): string {
        return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value: string) {
        this._setOption('horizontalAlignment', value);
    }

    
    get verticalAlignment(): string {
        return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value: string) {
        this._setOption('verticalAlignment', value);
    }

    
    get argumentFormat(): DevExpress.ui.format|
        string {
        return this._getOption('argumentFormat');
    }
    set argumentFormat(value: DevExpress.ui.format|
        string) {
        this._setOption('argumentFormat', value);
    }

    
    get argumentPrecision(): number {
        return this._getOption('argumentPrecision');
    }
    set argumentPrecision(value: number) {
        this._setOption('argumentPrecision', value);
    }

    
    get location(): string {
        return this._getOption('location');
    }
    set location(value: string) {
        this._setOption('location', value);
    }

    
    get percentPrecision(): number {
        return this._getOption('percentPrecision');
    }
    set percentPrecision(value: number) {
        this._setOption('percentPrecision', value);
    }

    
    get shared(): boolean {
        return this._getOption('shared');
    }
    set shared(value: boolean) {
        this._setOption('shared', value);
    }

    
    get isShown(): boolean {
        return this._getOption('isShown');
    }
    set isShown(value: boolean) {
        this._setOption('isShown', value);
    }

    
    get text(): string {
        return this._getOption('text');
    }
    set text(value: string) {
        this._setOption('text', value);
    }

    
    get position(): string {
        return this._getOption('position');
    }
    set position(value: string) {
        this._setOption('position', value);
    }

    
    get showMode(): string {
        return this._getOption('showMode');
    }
    set showMode(value: string) {
        this._setOption('showMode', value);
    }

    protected get _optionPath() {
        return 'tooltip';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-tooltip',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'arrowLength': [{ type: Input },],
'border': [{ type: Input },],
'color': [{ type: Input },],
'container': [{ type: Input },],
'customizeTooltip': [{ type: Input },],
'enabled': [{ type: Input },],
'font': [{ type: Input },],
'format': [{ type: Input },],
'opacity': [{ type: Input },],
'paddingLeftRight': [{ type: Input },],
'paddingTopBottom': [{ type: Input },],
'precision': [{ type: Input },],
'shadow': [{ type: Input },],
'zIndex': [{ type: Input },],
'horizontalAlignment': [{ type: Input },],
'verticalAlignment': [{ type: Input },],
'argumentFormat': [{ type: Input },],
'argumentPrecision': [{ type: Input },],
'location': [{ type: Input },],
'percentPrecision': [{ type: Input },],
'shared': [{ type: Input },],
'isShown': [{ type: Input },],
'text': [{ type: Input },],
'position': [{ type: Input },],
'showMode': [{ type: Input },],
};
}


export class DxoTooltipModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoTooltipComponent
  ],
  exports: [
    DxoTooltipComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
